import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {map, Observable} from 'rxjs';
import {loadedUserState} from '@shared/route-utils';

/**
 * Restricts a route to administrators (the main account or an admin sub-user). Non-administrators
 * — e.g. a 'User'-role sub-user — are redirected back to the user-administration list. Used to
 * keep them out of the create-user flow, which the backend also rejects.
 */
export const administratorGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
    const router = inject(Router);
    return loadedUserState().pipe(
        map(state =>
            state.status === 'success' && state.user.role === 'ADMINISTRATOR'
                ? true
                : router.createUrlTree(['/admin/user-administration']),
        ),
    );
};
